import { render, staticRenderFns } from "./DeleteBackupRepoDialog.vue?vue&type=template&id=3078589c&"
import script from "./DeleteBackupRepoDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteBackupRepoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports